<template>
  <transition name="modal-fade">
    <div
      class="modal-overlay"
      v-if="mostrar"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h3>Fale Conosco</h3>
          <button
            class="fechar"
            @click="fechar"
          >
            &times;
          </button>
        </div>

        <div class="modal-body">
          <p class="modal-descricao">
            Envie uma mensagem diretamente para o coordenador da ação
            <strong>{{ tituloAcao }}</strong
            >.
          </p>

          <div class="form-group">
            <label for="assuntoInput">Assunto</label>
            <input
              id="assuntoInput"
              type="text"
              v-model="assunto"
              placeholder="Digite o assunto da mensagem"
              class="input-estilizado"
            />
          </div>

          <div class="form-group">
            <label for="mensagemInput">Mensagem</label>
            <textarea
              id="mensagemInput"
              v-model="mensagem"
              placeholder="Digite sua mensagem aqui..."
              class="input-estilizado"
              rows="7"
              style="resize: vertical; min-height: 180px"
            ></textarea>
          </div>

          <div class="modal-actions">
            <button
              class="btn-cancelar"
              @click="fechar"
            >
              Cancelar
            </button>
            <button
              class="btn-enviar"
              @click="enviarMensagem"
              :disabled="enviando"
            >
              {{ enviando ? "Enviando..." : "Enviar Mensagem" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, watch } from "vue";
import acaoService from "@/service/acaoService";

const props = defineProps({
  mostrar: Boolean,
  acaoId: [String, Number],
  tituloAcao: String,
  emailCoordenador: String,
});

const emit = defineEmits(["fechar", "enviado"]);

const assunto = ref("");
const mensagem = ref("");
const enviando = ref(false);

watch(
  () => props.mostrar,
  (newVal) => {
    if (newVal) {
      assunto.value = "";
      mensagem.value = "";
      enviando.value = false;
    }
  }
);

function fechar() {
  emit("fechar");
}

async function enviarMensagem() {
  if (!assunto.value.trim() || !mensagem.value.trim()) {
    alert("Por favor, preencha o assunto e a mensagem.");
    return;
  }

  try {
    enviando.value = true;

    await acaoService.enviarEmailCoordenador(
      props.acaoId,
      assunto.value,
      mensagem.value,
      props.emailCoordenador
    );

    alert("Mensagem enviada com sucesso ao coordenador!");
    emit("enviado");
    fechar();
  } catch (error) {
    alert("Erro ao enviar a mensagem. Tente novamente mais tarde.");
  } finally {
    enviando.value = false;
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 800px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.modal-header {
  background-color: #482a89;
  color: white;
  padding: 15px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.modal-header h3 {
  margin: 0;
  font-size: 1.2rem;
}

.fechar {
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  line-height: 1;
  position: absolute;
  right: 20px;
}

.modal-body {
  padding: 20px;
}

.modal-descricao {
  font-size: 14px;
  color: #666;
  margin-bottom: 25px;
  text-align: center;
}

.form-group {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.form-group label {
  font-weight: 500;
  margin-bottom: 8px;
  color: #333;
  text-align: center;
}

.input-estilizado {
  width: 450px;
  max-width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
}

.input-estilizado:focus {
  border-color: #482a89;
  outline: none;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  font-size: 1rem;
  transition: background-color 0.2s;
}

.btn-cancelar {
  background-color: #f1f1f1;
  color: #333;
}

.btn-cancelar:hover {
  background-color: #e4e4e4;
}

.btn-enviar {
  background-color: #482a89;
  color: white;
}

.btn-enviar:hover {
  background-color: #3a226d;
}

.btn-enviar:disabled {
  background-color: #999;
  cursor: not-allowed;
}

/* Transição do Modal */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active .modal-content,
.modal-fade-leave-active .modal-content {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.modal-fade-enter-from .modal-content,
.modal-fade-leave-to .modal-content {
  transform: scale(0.95) translateY(-20px);
}
</style>
